import React, { FC, useEffect, useRef, useState } from "react";
import {
  Input,
  Button,
  Modal,
  Row,
  Col,
  Dropdown,
  Menu,
  Switch,
  Radio,
  List,
  Avatar,
  Badge,
} from "antd";
import Icon, {
  CloseOutlined,
  DeleteOutlined,
  LockOutlined,
  HomeOutlined,
  PlusOutlined,
  SettingOutlined,
  SplitCellsOutlined,
  MailOutlined,
  UserOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";

import {
  GET_PAGE,
  GET_USERS_LIST,
  GET_ALL_FRIEND_PAGE,
  GET_ADMIN_GROUPS,
  GET_ADMIN_GROUP_MEMBERS,
} from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";
import {
  wrapRequestPayload,
  getMessageRequestPayload,
} from "../../helpers/request/RequestPayload";
import InvitePeopleModal from "components/Modals/InvitePeopleModal";

import useLocalStorageService from "../../services/localStorage";
import { SocketTopics } from "../../constants/enums";
import { CID, UUID, RID } from "../../constants/localStoreKeys";
import { ReactSVG } from "react-svg";

import {
  getModifyPageSubscriptionTopic,
  getMembersRemoveFromPagePublishTopic,
} from "hooks/MQTTConstants";

import { getUserById } from "utils/chatUtils";
import {formatUserFilterText} from "utils/appUtil";
import AddPeople from "./AddPeople";
import "./PeopleModal.scss";
import MembersPopup from "./MembersPopup";
import AvatarItem from "./AvatarItem";


const PeopleModal: FC<{ onClose: () => void; socket?: ISocket }> = ({
  onClose,
  socket,
}) => {
  const { selectedItem } =
    useSelector((state: RootState) => state.search);
  const { findUsersToPage, allUsers } = useSelector(
    (state: RootState) => state.auth
  );
  const scrollRef = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [selectedUsers, setSelectedUsers] = useState<any>({});
  const [selectedGroups, setSelectedGroups] = useState<any>({});
  const [isAddPeopleOpen, setIsAddPeopleOpen] = useState(false);
  const [isInviteOpen, setIsInviteOpen] = useState(false);
  const [groupMembersList, setGroupMembersList] = useState({});
  const { adminRoles } = useSelector((state: RootState) => state.dashboard);
  const { requestIds } = useSelector((state: RootState) => state.dashboard);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [isBreakLoading, setIsBreakLoading] = useState(false);
  const [isMembersLoading, setIsMembersLoading] = useState(false);


  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const dispatch = useDispatch();

  const { getLocalStorageItem } = useLocalStorageService();

  const aggregateUser = (inputQueryId: string, filterText?: string) => {
    var searchQuery = `@userType:{user}`;
    console.log('filter text', filterText);
    if (filterText && filterText.length > 2) {
      searchQuery += formatUserFilterText(filterText);
    }
    console.log('search query', searchQuery);
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/bds/aggregateBds`,
      wrapRequestPayload({
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: searchQuery,
            searchOptions: "TIMEOUT 10000",
          },
          list: {
            inputQueryId: inputQueryId,
          },
          load: {
            objectId: "$.objectId",
            liveObject: "$.persistent.static",
            status: "$.nonpersistent.static.live.status"
          },
        },
        groupBy: {
          properties: ["@objectId"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@liveObject"],
              name: "profile",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        filter: {
          expression: "",
        },
        result: {
          pagination: {
            offset: 0,
            limit: 10000,
          },
        },
        anyStatus: false,
      }, requestIds.user)
    );
  };

  useEffect(() => {
    if (selectedItem) {
      const orgGroups =
        selectedItem?.persistent?.static?.metadata?.members?.orgGroups || {};
      const users =
        selectedItem?.persistent?.static?.metadata?.members?.users || {};
      const orgUsersSet = new Set([]);
      Object.keys(orgGroups)?.map((group) => {
        orgGroups[group].userIds.map((user) => {
          orgUsersSet.add(user);
        });
      });
      const orgUsersArray = Array.from(orgUsersSet);

      orgUsersArray.map((user) => {
        if (users?.[user]?.role === "write") {
          delete users?.[user];
        }
      });

      setSelectedUsers(users);

      setSelectedGroups(orgGroups);

      setIsBreakLoading(false);
      setIsDeleteLoading(false);

      dispatch(GET_PAGE({ payload: {} }));
      dispatch(GET_ALL_FRIEND_PAGE({ payload: {} }));
    }
  }, [selectedItem]);

  // useEffect(() => {
  //   if (findUsersToPage) {
  //     aggregateUser(findUsersToPage.queryId);
  //   }
  // }, [findUsersToPage]);


  const sendPageUpdateEvent = (type, attributes) => {
    const modifyPagePayload: IMessage = getMessageRequestPayload(
      getLocalStorageItem(CID),
      getLocalStorageItem(RID),
      selectedItem.pageId,
      "",
      type,
      attributes
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getModifyPageSubscriptionTopic(selectedItem.pageId),
      wrapRequestPayload(modifyPagePayload)
    );
  };

  const removePage = (page) => {
    setIsDeleteLoading(true);
    sendPageUpdateEvent("removeAdminGroup", {
      queryId: page.queryId,
    });
  };

  const breakPage = (page) => {
    setIsBreakLoading(true);
    sendPageUpdateEvent("breakAdminGroup", {
      queryId: page.queryId,
    });
  };

  const removeUser = (user) => {
    delete selectedUsers[user];
    const users = { ...selectedUsers };
    setSelectedUsers(users);
    sendPageUpdateEvent("removePageMember", {
      userId: user,
    });
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getMembersRemoveFromPagePublishTopic(user),
      {
        pattern: getMembersRemoveFromPagePublishTopic(user),
        data: selectedItem.pageId,
      }
    );
    if (scrollRef) {
      scrollRef.current.scrollTop = 0;
    }
  };


  const openInvitePopup = () => {
    setIsAddPeopleOpen(false);
    setIsInviteOpen(true);
  };

  const openAddPeoplePopup = () => {
    setIsAddPeopleOpen(true);
    setIsInviteOpen(false);
  };

  return (
    <React.Fragment>
      <Modal
        title=""
        visible={isModalVisible}
        onOk={() => { }}
        onCancel={handleCancel}
        width="450px"
        className="beam-modal scrollable max-height-fix"
        footer={[]}
        closable={false}
        destroyOnClose={true}
      >
        {!isAddPeopleOpen && !isInviteOpen && (
          <div>
            <Row className="d-flex mt-1 mb-4">
              <Col span={24}>
                <h3>People
                  <button onClick={onClose} className="pull-right b-0 rm-b"><CloseOutlined /></button>
                </h3>
              </Col>
            </Row>
            <Row className="scrollable-body mt-4" ref={scrollRef}>
              <Col span={24}>
                <Row className="d-flex mb-1">
                  <Col span={24}>
                    <Button title={selectedItem.currentUserRole === "edit" ? 'Add participants' : 'Not authorized'} disabled={selectedItem.currentUserRole !== "edit"} onClick={openAddPeoplePopup} className="beam-btn green-btn bordered"><PlusOutlined className="p-1 mb-2" />Add participants</Button>
                    <Button onClick={openInvitePopup} disabled={selectedItem.currentUserRole !== "edit"} className="beam-btn orange-btn bordered ml-2"><MailOutlined className="p-1 mb-2" />Invite</Button>
                  </Col>
                </Row>
                {selectedUsers &&
                  Object.keys(selectedUsers).map((member, index) => (
                    <AvatarItem index={index} key={member} isDelete={true} isPermissionPopup={true}
                      socket={socket}
                      user={{ id: member, ...selectedUsers[member], ...getUserById(member, allUsers) }}
                      selectedItem={selectedItem} removeUser={() => removeUser(member)}
                      onCloseParentModal={onClose}></AvatarItem>
                  ))}

                {selectedGroups.length > 0 && (
                  <div>
                    <span>Groups</span>
                  </div>
                )}
                
                {selectedGroups &&
                  Object.keys(selectedGroups).map((group) => (
                    <Row
                      className="person-item"
                      key={selectedGroups[group].queryId}
                    >
                      <Col span={4}>
                        <ReactSVG
                          src={`/images/community-blue-icon.svg`}
                          className="colorable mark-icon"
                        />
                      </Col>
                      <Col span={8}>
                        <h5>{selectedGroups[group].name}</h5>
                      </Col>
                      <Col span={12} className="t-right">
                        {selectedItem && selectedItem.currentUserRole === "edit" && (
                          <React.Fragment>
                            <Button
                              disabled={isBreakLoading}
                              loading={isDeleteLoading}
                              className="beam-btn mr-1 orange-btn button no-shadow cover"
                              onClick={() => {
                                removePage(selectedGroups[group]);
                              }}
                            >
                              {
                                (<DeleteOutlined className="text-white" />)}
                            </Button>

                            <Button
                              disabled={isDeleteLoading}
                              loading={isBreakLoading}
                              className="beam-btn green-btn button no-shadow cover mr-1"
                              onClick={() => {
                                breakPage(selectedGroups[group]);
                              }}
                            >
                              {(<SplitCellsOutlined className="text-white" />)}
                            </Button>

                            <Dropdown
                              trigger={["click"]}
                              onVisibleChange={(visible) => {
                                if (visible) {
                                  const queryId = selectedGroups[group].queryId;
                                  if (queryId) {
                                    setIsMembersLoading(true);
                                    dispatch(
                                      GET_ADMIN_GROUP_MEMBERS({
                                        queryId,
                                        callback: (response) => {
                                          const members = {};
                                          response?.data?.list.map((user) => {
                                            if (user.split(":")?.[1] === 'user') {
                                              members[user.split(":")?.[2]] = {};
                                            }
                                            return user;
                                          });
                                          setGroupMembersList({
                                            ...groupMembersList,
                                            [selectedGroups[group].queryId]:
                                              members,
                                          });
                                        },
                                      })
                                    );
                                    setIsMembersLoading(false);
                                  }
                                }
                              }}
                              overlay={<MembersPopup
                                adminRoles={adminRoles}
                                allUsers={allUsers}
                                isMembersLoading={isMembersLoading}
                                users={
                                  groupMembersList?.[selectedGroups[group].queryId]
                                }
                              ></MembersPopup>}
                              className="message-dropdown"
                              placement="bottomRight"
                            >
                              <a
                                className="ant-dropdown-link"
                                onClick={(e) => e.preventDefault()}
                              >
                                <Button
                                  className="beam-btn no-shadow">
                                  <UserOutlined />
                                </Button>
                              </a>
                            </Dropdown>
                          </React.Fragment>
                        )}
                      </Col>
                    </Row>
                  ))}

              </Col>
            </Row></div>)}
        {isAddPeopleOpen && (<AddPeople onClose={() => setIsAddPeopleOpen(false)} socket={socket}></AddPeople>)}
        {isInviteOpen && (<InvitePeopleModal
          socket={socket}
          onClose={() => { setIsInviteOpen(false) }}
          page={true}
        />)}
      </Modal>
    </React.Fragment>
  );
};

export default PeopleModal;
